<template>
    <div>
        <!-- General Notes -->
        <noncustom-prop v-if="object.restrict" :object='object' :property='{label: object.restrict.label, column: "restrict"}'>
        </noncustom-prop>

        <!-- Provenance -->
        <noncustom-prop v-if="object.referenced" :object='object' :property='{label: object.referenced.label, column: "referenced"}'>
        </noncustom-prop>

        <!-- Size -->
        <noncustom-prop v-if="object.volume" :object='object' :property='{label: object.volume.label, column: "volume"}'>
        </noncustom-prop>
    </div>
</template>

<script>
    import manageProperties from './../../../mixins/manageProperties.js'
    import NoncustomVue from '../parts/noncustom.vue'

    export default {
        props: ['object'],
        mixins: [manageProperties],
        components: {
            'noncustom-prop': NoncustomVue,
        }
    }
</script>



